module.exports = __webpack_public_path__ + "img/2.1fff1bb2.png";